import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28.995 6.85A2 2 0 0 0 27 5H5l-.15.005A2 2 0 0 0 3 7v18l.005.15A2 2 0 0 0 5 27h22l.15-.006A2 2 0 0 0 29 25V7zM5 21.415l6-6L16.586 21l.13.119A2 2 0 0 0 19.414 21L22 18.414l5 5.001V25H5zM27 7H5v11.584L9.586 14a2 2 0 0 1 2.698-.119l.13.119L18 19.586 20.586 17a2 2 0 0 1 2.698-.119l.13.119L27 20.585zm-6 5.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconPhotos = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconPhotos);
export default Memo;
